import useGetNewspaperEditorsAll from './useGetNewspaperEditorsAll'

export default useGetNewspaperEditorsAll
